<template>
	<div class="goals-toolbar">
		<div class="segment" v-if="showTeamDropDown">
			<TeamDropDown
				class="goals-toolbar__team-dropdown"
				:disabled="disabled"
				:options="teamOptions"
				:value="selectedValue"
				@change="onTeamChange"
			/>
		</div>
		<div class="segment">
			<GoalCountChip
				class="goals-toolbar__goal-count-chip"
				:goal-type="enums.GoalType.ACTIVE"
				:count="activeCount"
				:is-selected="selectedGoalType === enums.GoalType.ACTIVE"
				@click="onGoalCountChipClicked( enums.GoalType.ACTIVE )"
			/>
			<GoalCountChip
				class="goals-toolbar__goal-count-chip"
				:goal-type="enums.GoalType.DRAFT"
				:count="draftCount"
				:is-selected="selectedGoalType === enums.GoalType.DRAFT"
				@click="onGoalCountChipClicked( enums.GoalType.DRAFT )"
			/>
			<GoalCountChip
				class="goals-toolbar__goal-count-chip"
				:goal-type="enums.GoalType.ARCHIVED"
				:count="archivedCount"
				:is-selected="selectedGoalType === enums.GoalType.ARCHIVED"
				@click="onGoalCountChipClicked( enums.GoalType.ARCHIVED )"
			/>
		</div>
		<div class="segment"></div>
	</div>
</template>

<script>
import { GoalType } from "@teaming/common-enums";
import { EnumsMixin, TeamDropDown } from "@teaming/common-ui";
import GoalCountChip from "./GoalCountChip";

export default {
	name: "MyGoalsToolbar",
	emits: [ "goalTypeChanged", "teamChanged", ],
	mixins: [ EnumsMixin, ],
	components: {
		GoalCountChip,
		TeamDropDown,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		teamOptions: {
			type: Array,
			required: true,
		},
		selectedTeam: {
			type: Object,
			required: true,
		},
		activeCount: {
			type: Number,
			required: true,
		},
		draftCount: {
			type: Number,
			required: true,
		},
		archivedCount: {
			type: Number,
			required: true,
		},
		selectedGoalType: {
			type: String,
			required: true,
			validator( value ) {
				return GoalType.includes( value );
			},
		},
		showTeamDropDown: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		selectedValue() {
			return ( this.selectedTeam?.id || "" ).toString();
		},
	},
	methods: {
		onTeamChange( e ) {
			if ( !e ) {
				return;
			}

			const { value: teamId, } = e;
			if ( teamId === this.selectedTeam?.id ) {
				return;
			}

			this.$emit( "teamChanged", teamId );
		},
		onGoalCountChipClicked( goalType ) {
			if ( this.disabled ) {
				return;
			}
			this.$emit( "goalTypeChanged", goalType );
		},
	},
};
</script>

<style lang="scss" scoped>
.goals-toolbar {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 1rem;

	@include for-size('md') {
		flex-direction: row;
	}
}

.goals-toolbar > .segment {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	width: 100%;
	gap: 0.5rem;

	@include for-size('md') {
		width: auto;
	}
}

.goals-toolbar__team-dropdown {
	width: 100%;

	@include for-size('md') {
		width: 18.75rem;
	}
}

.goals-toolbar__goal-count-chip {
	width: auto;
}
</style>
